export class ApiError extends Error {
  status: number;
  code: string;
  details: unknown;

  constructor(status: number, code: string, message: string, details?: unknown) {
    super(message);
    this.status = status;
    this.code = code;
    this.details = details;
  }
}

let activeBusinessId: string | null = null;

export function setActiveBusiness(id: string | null): void {
  activeBusinessId = id;
}

export function getActiveBusiness(): string | null {
  return activeBusinessId;
}

type Method = 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';

export async function request<T>(
  method: Method,
  path: string,
  body?: unknown,
  options: { idempotencyKey?: string; headers?: Record<string, string> } = {}
): Promise<T> {
  const headers: Record<string, string> = { ...(options.headers ?? {}) };
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  if (activeBusinessId) headers['X-Business-Id'] = activeBusinessId;
  if (options.idempotencyKey) headers['Idempotency-Key'] = options.idempotencyKey;

  const res = await fetch(path, {
    method,
    headers,
    credentials: 'same-origin',
    body: body === undefined ? undefined : JSON.stringify(body)
  });

  const text = await res.text();
  const payload = text ? safeParse(text) : {};

  if (!res.ok) {
    const err = (payload as { error?: { code?: string; message?: string; details?: unknown } }).error;
    throw new ApiError(res.status, err?.code ?? 'request_failed', err?.message ?? 'Não foi possível concluir a operação.', err?.details);
  }
  return payload as T;
}

function safeParse(text: string): unknown {
  try {
    return JSON.parse(text);
  } catch {
    return { raw: text };
  }
}

export const api = {
  get: <T>(path: string) => request<T>('GET', path),
  post: <T>(path: string, body?: unknown, options?: { idempotencyKey?: string }) => request<T>('POST', path, body, options),
  patch: <T>(path: string, body?: unknown) => request<T>('PATCH', path, body),
  put: <T>(path: string, body?: unknown) => request<T>('PUT', path, body),
  del: <T>(path: string, body?: unknown) => request<T>('DELETE', path, body)
};
